import { render, staticRenderFns } from "./SelectDrugOrga.vue?vue&type=template&id=cbd943da&scoped=true"
import script from "./SelectDrugOrga.vue?vue&type=script&lang=js"
export * from "./SelectDrugOrga.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbd943da",
  null
  
)

export default component.exports